module.exports = __webpack_public_path__ + "fonts/manrope-semibold.612e36e4.otf";